export default __webpack_public_path__ + "static/media/scheduled-message.290b4b2e.svg";